import React from 'react';
import costco from '../assets/cotsco.png';
import sams from '../assets/sams.png';
import walmart from '../assets/walmart.png';

const Services = () => {
  return (
    <>
      {/* Services Section */}
      <section className="py-20 px-6 bg-white text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-[#003366] mb-10">Our Services</h2>
        <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-8 text-left text-gray-700">
          <div>
            <h3 className="text-xl font-semibold mb-2">Freight Transportation</h3>
            <p>We offer dependable freight services across the United States, ensuring timely and safe cargo delivery for businesses of all sizes.</p>
          </div>
          <div>
            <h3 className="text-xl font-semibold mb-2">Logistics Solutions</h3>
            <p>From route planning to last-mile delivery, our logistics services are tailored to meet your specific operational needs efficiently.</p>
          </div>
          <div>
            <h3 className="text-xl font-semibold mb-2">Dedicated Fleet Services</h3>
            <p>Partner with us for dedicated trucking solutions that ensure exclusive fleet availability and brand-aligned service execution.</p>
          </div>
        </div>
      </section>

      {/* Clients Section */}
      <section className="py-16 px-6 bg-[#f9f9f9] text-center">
        <h3 className="text-2xl md:text-3xl font-bold text-[#003366] mb-8">Our Clients</h3>
        <p className="text-gray-600 mb-10 max-w-xl mx-auto">
          We’re proud to partner with some of the most trusted brands in retail and logistics.
        </p>
        <div className="max-w-4xl mx-auto grid grid-cols-2 md:grid-cols-3 gap-8 items-center justify-center">
          <img src={costco} alt="Cosco" className="h-18 object-contain mx-auto" />
          <img src={sams} alt="Sam's Club" className="h-18 object-contain mx-auto" />
          <img src={walmart} alt="Walmart" className="h-18 object-contain mx-auto" />
        </div>
      </section>
    </>
  );
};

export default Services;
